module.exports = {
      id: "sprite-icon_phone-usage",
      viewBox: "0 0 28 28",
      url: __webpack_public_path__ + "svgs/sprite-2389f1.svg#sprite-icon_phone",
      toString: function () {
        return this.url;
      }
    }